// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-pointer[data-v-6d3f39ca]{cursor:pointer}.iconColumn__mdieye[data-v-6d3f39ca]{width:10px;padding:0!important}.tdCenterIcon[data-v-6d3f39ca]{padding-top:.3rem!important}.sizeText[data-v-6d3f39ca],.td__icon[data-v-6d3f39ca]{padding-right:0!important}@media screen and (max-width:600px){.sizeIcon[data-v-6d3f39ca]{padding-right:0!important}.sizeText[data-v-6d3f39ca]{padding-left:0!important}}", ""]);
// Exports
module.exports = exports;
